import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import VendorPicker from '../../components/vendorPicker'
const options = {
	'amazon':[
		{
			label:"DEFAULT", 
			value:"DEFAULT"
		},
		{
			label:"AMAZON_NA",
			value:"AMAZON_NA"
		}
	],
	'mercado':[
		{
			label:"Mercado Envíos gratis",
			value:"Mercado Envíos gratis",
		},
		{
			label:"Mercado Envíos a cargo del comprador",
			value:"Mercado Envíos a cargo del comprador"
		}
	]
}
const ProductCreate = ({open, close, ...rest}) => {
  const { products, vendor, recall, setRecall} = React.useContext(AppContext)
  const title = "Añadir Producto"
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
			<VendorPicker/>
      {vendor &&(<ObjectForm ignored={['id']} recall={recall} submit={products.create}
  			stc={{ vendor, status:'UI'}}
				labels={{  cost: "Costo (centavos)" }}
        obj={{ sku:"", asin:"", name:"", cost:null, fulfillment:"", description:"", cost:0 }}
        types={{ sku:'text', asin:'text', name:'text', cost:'money', cost:'money', description:'textarea', fulfillment:'select' }}
        options={{ fulfillment: options[vendor] }} 
        controlled={{ cost: 0 }}
        changed={{}} 
      />)}
      <Button onClick={() => {setRecall(true);close()}}>Añadir</Button>
    </Dialog>
  )
}
export default ProductCreate